<ion-header>
    <ion-toolbar>
        <ion-buttons slot="start">
            <ion-back-button data-test="backButton"></ion-back-button>
        </ion-buttons>
        <ion-title data-test="title" #title (click)="onTitleClick()">Campaign</ion-title>
        <ion-buttons slot="end">
            <ion-button data-test="more" [disabled]=vb.disabled color="light" id="more" (click)="onMoreClick($event)">
                <ion-icon name="ellipsis-horizontal"></ion-icon>
            </ion-button>
        </ion-buttons>
    </ion-toolbar>
</ion-header>

<ion-content class="ion-no-padding">
    <ion-list-header color="secondary" class="ion-text-wrap">
        To add a campaign, complete the 2 steps below:
    </ion-list-header>

    <ion-list>
        <ion-grid>
            <ion-row>
                <ion-col>
                    <ion-card class="default">
                        <ion-card-header>
                            <div class="title">Incentive Set Selection</div>
                            <div class="version">Select the incentive set that should be sent to your customers.</div>
                        </ion-card-header>

                        <ion-card-content class="ion-no-padding">
                            <ion-button data-test="selectIncentiveSet" class="selectCustomerBtn" color="primary"
                                expand="full" [disabled]="isDisabled()" (click)="onIncentiveSetPrompt()">Select
                                Incentive Set</ion-button>
                            <!-- @if (selectedCustomers.length > 0) {
                                    <div class="selectedCustomers">
                                        {{getNumSelectedCustomersStr()}}
                                    </div>
                            } -->
                        </ion-card-content>
                    </ion-card>
                </ion-col>
            </ion-row>

            <ion-row>
                <ion-col>
                    <!-- <ion-card class="default" [disabled]="selectedCustomers.length === 0"> -->
                    <ion-card class="default">
                        <ion-card-header>
                            <div class="title">Send Campaign</div>
                            <!-- <div class="version">Send the campaign to the selected customers</div> -->
                            @if (!isInvalidIncentiveSetName()) {
                            <div class="version">Send the
                                '{{selectedIncentiveSet.setName}}' incentive set to {{numCustomers}} customers?</div>
                            }
                        </ion-card-header>

                        <ion-card-content class="ion-no-padding">
                            <ion-button data-test="sendCampaign" class="sendCampaignBtn" color="primary" expand="full"
                                (click)="onSendCampaignClick()" [disabled]="isInvalidIncentiveSetName()">
                                Send Campaign
                            </ion-button>
                        </ion-card-content>
                    </ion-card>
                </ion-col>
            </ion-row>
        </ion-grid>
    </ion-list>
</ion-content>